import { useAppSelector } from 'store/hooks';
import type { PayHubWidgetContractsUserCardResponse } from 'store/models';

import { isReservationFlowActive } from '../utils/reservationFlags';

/**
 * `has_reserved_deposit` is on the `GET /v1/user-cards/{amount}` response but not in
 * `APIModels.ts`, which is regenerated from swagger. Read through a local extension so the
 * generated file stays untouched and the field disappears with this directory.
 */
export interface ReservationUserCard extends PayHubWidgetContractsUserCardResponse {
  has_reserved_deposit?: boolean;
}

/**
 * The card that already carries a hold from an earlier session, if any.
 *
 * Contract: such a card is preselected, and the player is taken back to its hold page to finish the
 * verification the money is waiting on. Returning it lets the form preselect it; the side effect
 * seeds the flow's own cache so the screens know which card the statement belongs to.
 *
 * Naturally inert when the feature is off — the field is simply absent from the response.
 */
export const useReservedCard = (
  cards?: PayHubWidgetContractsUserCardResponse[] | null,
): ReservationUserCard | undefined => {
  const isActive = useAppSelector(isReservationFlowActive);

  return isActive
    ? (cards as ReservationUserCard[] | null | undefined)?.find((card) => card.has_reserved_deposit)
    : undefined;
};
